import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Filter } from '../../../../shared/constants/Filters';
import { LeadsFilterLocalStorageDto } from '../../../../shared/models/common/filters/leadsFilterLocalStorage.dto';
import { AuthService } from '../../../../shared/services/security/auth.service';
import { AssignmentRuleFilters } from '../../../profile/assignmentRuleFilters';
import { PositiveRulesDropdownComponent } from '../../dropdown/active-rules-dropdown/positive-rules-dropdown.component';
import { BrandSelectionDropdownComponent } from '../../dropdown/brand-selection-dropdown/brand-selection-dropdown.component';
import { ChannelSelectionDropdownComponent } from '../../dropdown/channel-selection-dropdown/channel-selection-dropdown.component';
import { DealerSelectionDropdownComponent } from '../../dropdown/dealer-selection-dropdown/dealer-selection-dropdown.component';
import { OriginSelectionDropdownComponent } from '../../dropdown/origin-selection-dropdown/origin-selection-dropdown.component';
import { ActiveRulesDropdownComponent } from '../../dropdown/positive-rules-dropdown/active-rules-dropdown.component';
import { TypeSelectionDropdownComponent } from '../../dropdown/type-selection-dropdown/type-selection-dropdown.component';
import { UserSelectionByRoleDropdownComponent } from '../../dropdown/user-selection-by-role-dropdown/user-selection-by-role-dropdown.component';
import { AssignmentRulesComunicationService } from './../../../../pages/profile/assignment-rules-comunication.service';

@Component({
  selector: 'ngx-assignment-rules-profile-filters',
  templateUrl: './assignment-rules-profile-filters.component.html',
  styleUrls: ['./assignment-rules-profile-filters.component.scss']
})
export class AssignmentRulesProfileFiltersComponent implements OnInit, AfterViewInit {

  sending = false;
  brandsSelected: any;
  typesSelected: any;
  channelsSelected: any;
  companySelected: any;
  filterName = Filter.ASSIGNMENT_RULES;
  usersSelected: any;
  channelSelected: any;
  originSelected: any;
  filter: AssignmentRuleFilters;

  dealersSelected: any;
  postalCodeFilterInputType: string;
  checkContactFilter: string;

  positiveRulesSelected: string[];
  onDeSelectPositiveRules: string;

  activeRulesSelected: string[];
  onDeSelectActiveRules: string;
  checkPostalCodeFilter = true;
  rangeSelected: string;
  dateModel: string;
  rangeUpdatedSelected: string;
  dateUpdateModel: string;
  filterDateUpdate: string;
  today = moment();
  rangeUpdate: { start: Date; end: Date };

  @ViewChild(UserSelectionByRoleDropdownComponent, { static: false })
  userSelectionComponent: UserSelectionByRoleDropdownComponent;
  @ViewChild(BrandSelectionDropdownComponent, { static: false })
  brandSelectionComponent: BrandSelectionDropdownComponent;
  @ViewChild(ChannelSelectionDropdownComponent, { static: false })
  channelSelectionComponent: ChannelSelectionDropdownComponent;
  @ViewChild(DealerSelectionDropdownComponent, { static: false })
  dealerSelectionComponent: DealerSelectionDropdownComponent;
  @ViewChild(TypeSelectionDropdownComponent, { static: false })
  typesSelectionComponent: TypeSelectionDropdownComponent;
  @ViewChild(ActiveRulesDropdownComponent, { static: false })
  activeRulesSelectionComponent: ActiveRulesDropdownComponent;
  @ViewChild(PositiveRulesDropdownComponent, { static: false })
  positiveRulesSelectionComponent: PositiveRulesDropdownComponent;
  @ViewChild(OriginSelectionDropdownComponent, { static: false })
  originSelectionComponent: OriginSelectionDropdownComponent;

  get haveFiltersApplied(): any {
    return Boolean(
      this.filter.assignmentRuleName ||
      this.filter.positiveRule ||
      this.filter.isActive ||
      this.filter.postalCode ||
      this.isDropdownElementFilterSelected()
    );
  }

  constructor(private readonly assignmentRulesComunicationService: AssignmentRulesComunicationService, private readonly authService: AuthService) {
    this.rangeUpdate = { start: null, end: null };
  }

  ngOnInit() {
    this.filter = new AssignmentRuleFilters();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.generateFilterFromLocalStorage();
      this.applyFilter();
    });
  }

  filterByPostalCode(option: string): void {
    this.filter.postalCode = '';
    if (this.filter.postalCodeType === option) {
      this.filter.postalCodeType = undefined;
      this.filter.postalCode = '';
      this.checkPostalCodeFilter = true;
      return;
    }

    this.filter.postalCodeType = option;

    if (this.filter.postalCode.length > 0) {
      this.checkMinOfPostalCodeFilter();
    } else {
      this.checkPostalCodeFilter = true;
    }

    if (option === 'filter_by_postal_code') {
      this.postalCodeFilterInputType = 'number';
    } else {
      this.postalCodeFilterInputType = 'text';
    }
  }

  checkMinOfPostalCodeFilter(): boolean {
    if (this.filter.postalCodeType && this.filter.postalCode.length === 0) {
      return this.checkPostalCodeFilter = true;
    }
    if (this.filter.postalCodeType && this.filter.postalCode) {
      return this.checkPostalCodeFilter = !(this.filter.postalCodeType && (this.filter.postalCode.length <= 2 && this.filter.postalCode.length !== 0));
    }
  }

  applyFilter() {
    this.sending = true;

    this.applySelectionComponents();

    this.filter.positiveRule = this.positiveRulesSelectionComponent
      ? this.positiveRulesSelectionComponent.selectedItems[0]
      : this.positiveRulesSelected || '';

    this.filter.isActive = this.activeRulesSelectionComponent
      ? this.activeRulesSelectionComponent.selectedItems[0]
      : this.activeRulesSelected || '';

    this.filter.leadType = this.typesSelectionComponent
      ? this.typesSelectionComponent.selectedItems.map((type) => type.id)
      : this.typesSelected || [];

    this.filter.origin = this.originSelectionComponent
      ? this.originSelectionComponent.selectedItems
      : this.originSelected || [];

    this.createDateUpdateRangeForFilter();

    this.saveFilter();

    this.assignmentRulesComunicationService.applyFilter(this.filter);
    this.sending = false;
  }

  resetFilter(): void {
    this.clearFilter();
    this.applyFilter();
  }

  clearFilter(): void {
    this.filter = new AssignmentRuleFilters();
    this.userSelectionComponent = null;
    this.usersSelected = [];
    this.brandSelectionComponent = null;
    this.brandsSelected = [];
    this.channelSelectionComponent = null;
    this.channelSelected = [];
    this.typesSelectionComponent = null;
    this.typesSelected = [];
    this.dealerSelectionComponent = null;
    this.dealersSelected = [];
    this.originSelectionComponent = null;
    this.originSelected = [];

    this.filter.isActive = null;
    if (this.activeRulesSelectionComponent) {
      this.activeRulesSelectionComponent.clearSelectedItems();
    }
    this.activeRulesSelected = null;

    this.filter.positiveRule = null;
    if (this.positiveRulesSelectionComponent) {
      this.positiveRulesSelectionComponent.clearSelectedItems();
    }
    this.positiveRulesSelected = null;

    this.checkPostalCodeFilter = true;
    this.filter.postalCode = '';
    this.filter.postalCodeType = undefined;
    this.filter.assignmentRuleName = '';
    this.clearDateUpdateFilter();
  }

  generateFilterFromLocalStorage(): void {
    const filterLocalStorage = JSON.parse(localStorage.getItem(this.filterName));
    if (!filterLocalStorage) {
      return;
    }

    if (this.userSelectionComponent) {
      this.userSelectionComponent.selectedItems =
        filterLocalStorage.userSelectionComponentSelectedItems;
      this.usersSelected = filterLocalStorage.userSelectionComponentSelectedItems;
    }

    if (this.brandSelectionComponent) {
      this.brandSelectionComponent.selectedItems =
        filterLocalStorage.brandSelectionComponentSelectedItems;
      this.brandsSelected =
        filterLocalStorage.brandSelectionComponentSelectedItems;
    }

    if (this.channelSelectionComponent) {
      this.channelSelectionComponent.selectedItems =
        filterLocalStorage.channelSelectionComponentSelectedItems;
      this.channelSelected =
        filterLocalStorage.channelSelectionComponentSelectedItems;
    }

    if (this.dealerSelectionComponent) {
      this.dealerSelectionComponent.selectedItems =
        filterLocalStorage.dealerSelectionComponentSelectedItems;
      this.dealersSelected =
        filterLocalStorage.dealerSelectionComponentSelectedItems;
    }

    if (this.typesSelectionComponent) {
      this.typesSelectionComponent.selectedItems =
        filterLocalStorage.typesSelectionComponentSelectedItems;
      this.typesSelected =
        filterLocalStorage.typesSelectionComponentSelectedItems;
    }

    if (this.originSelectionComponent) {
      this.originSelectionComponent.selectedItems =
        filterLocalStorage.originSelectedItem;
      this.originSelected =
        filterLocalStorage.originSelectedItem;
    }

    if (this.positiveRulesSelectionComponent) {
      this.positiveRulesSelectionComponent.itemSelected =
        filterLocalStorage.positiveRulesSelectionComponentSelectedItems[0];
      this.positiveRulesSelected =
        filterLocalStorage.positiveRulesSelectionComponentSelectedItems[0];
    }

    if (this.activeRulesSelectionComponent) {
      this.activeRulesSelectionComponent.itemSelected =
        filterLocalStorage.isActiveSelectionComponentSelectedItems[0];
      this.activeRulesSelected =
        filterLocalStorage.isActiveSelectionComponentSelectedItems[0];
    }
    this.rangeUpdate = {
      start: filterLocalStorage.updatedAtFrom
        ? new Date(filterLocalStorage.updatedAtFrom)
        : null,
      end: filterLocalStorage.updatedAtTo
        ? new Date(filterLocalStorage.updatedAtTo)
        : null,
    };

    this.filter.postalCode = filterLocalStorage.postalCode;
    this.filter.postalCodeType = filterLocalStorage.postalCodeType;
    this.filter.assignmentRuleName = filterLocalStorage.assignmentRuleName;
    this.dateUpdateModel = filterLocalStorage.dateUpdateModel;
    this.rangeUpdatedSelected = filterLocalStorage.rangeUpdatedSelected;
  }

  saveFilter(): void {
    const dropdownsObject = {
      users: this.userSelectionComponent,
      brands: this.brandSelectionComponent,
      channels: this.channelSelectionComponent,
      dealers: this.dealerSelectionComponent,
      types: this.typesSelectionComponent,
      origins: this.originSelectionComponent,
      positiveRules: this.positiveRulesSelectionComponent,
      activeRules: this.activeRulesSelectionComponent,
    };

    const filterUpdateCreateRanges = {
      dateModel: this.dateModel,
      rangeSelected: this.rangeSelected,
      dateUpdateModel: this.dateUpdateModel,
      rangeUpdatedSelected: this.rangeUpdatedSelected,
    };

    const filterLocalStorage = new LeadsFilterLocalStorageDto();

    filterLocalStorage.generateFilter(this.filter,
      dropdownsObject,
      null,
      filterUpdateCreateRanges,
      null
    );

    localStorage.setItem(this.filterName, JSON.stringify(filterLocalStorage));
  }

  selectDateUpdateFilter(amount: number, filter?: any): void {
    this.rangeUpdatedSelected = '';
    this.filterDateUpdate = filter;
    this.today = moment();
    const newdate = moment().subtract(amount, 'days');

    this.rangeUpdate.end =
      filter === 'yesterday' ? newdate.toDate() : this.today.toDate();

    this.rangeUpdate.start = newdate.toDate();
    this.rangeUpdate.start.setHours(0, 0, 0);
  }

  clearDateUpdateFilter(): void {
    this.filterDateUpdate = '';
    this.rangeUpdatedSelected = '';
    this.filter.updatedAtFrom = null;
    this.filter.updatedAtTo = null;
    this.dateUpdateModel = '';
    this.rangeUpdate = { start: null, end: null };
  }

  updatedDateRangeChange(range): void {
    let endDate = '?';
    if (range.end) {
      endDate = moment(range.end).format('D/M/YYYY');
    }
    this.rangeUpdatedSelected = `${moment(range.start).format(
      'D/M/YYYY'
    )} - ${endDate}`;
  }

  createDateUpdateRangeForFilter(): void {
    if (this.rangeUpdate.start) {
      this.filter.updatedAtFrom = this.rangeUpdate.start;
      if (!this.rangeUpdate.end) {
        this.rangeUpdate.end = new Date(this.rangeUpdate.start);
        this.rangeSelected = `${moment(this.rangeUpdate.start).format(
          'D/M/YYYY'
        )} - ${moment(this.rangeUpdate.end).format('D/M/YYYY')}`;
      }
      this.rangeUpdate.end.setHours(23, 59, 59);
      this.filter.updatedAtTo = this.rangeUpdate.end;
    }
  }

  private applySelectionComponents() {
    this.filter.user = this.userSelectionComponent
      ? this.userSelectionComponent.selectedItems.map((user) => user.id)
      : this.usersSelected || [];

    this.filter.dealer = this.dealerSelectionComponent
      ? this.dealerSelectionComponent.selectedItems.map((dealer) => dealer.id)
      : this.dealersSelected || [];

    this.filter.brand = this.brandSelectionComponent
      ? this.brandSelectionComponent.selectedItems.map((brand) => brand.id)
      : this.brandsSelected || [];

    this.filter.channel = this.channelSelectionComponent
      ? this.channelSelectionComponent.selectedItems.map((channel) => channel.id
      ) : this.channelSelected || [];
  }

  private isDropdownElementFilterSelected(): boolean {
    return Boolean(
      (this.userSelectionComponent && this.userSelectionComponent.selectedItems.length > 0) ||
      (this.typesSelectionComponent && this.typesSelectionComponent.selectedItems.length > 0) ||
      (this.dealerSelectionComponent && this.dealerSelectionComponent.selectedItems.length > 0) ||
      (this.brandSelectionComponent && this.brandSelectionComponent.selectedItems.length > 0) ||
      (this.channelSelectionComponent && this.channelSelectionComponent.selectedItems.length > 0) ||
      (this.positiveRulesSelectionComponent && this.positiveRulesSelectionComponent.selectedItems.length > 0) ||
      (this.activeRulesSelectionComponent && this.activeRulesSelectionComponent.selectedItems.length > 0) ||
      (this.originSelectionComponent && this.originSelectionComponent.selectedItems && this.originSelectionComponent.selectedItems.length > 0)
    );
  }
}
